export default __webpack_public_path__ + "static/media/man.51bf49f1.png";